import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { _InfinityFactoryContractGetAllDataByAddress } from "../../Services/Web3Connection";
import LaunchpadList from "../Launchpad/LaunchpadList";
import UpcomingTab from "./UpcomingTab";
import EndedTab from "./EndedTab";
import ActiveTab from "./ActiveTab";
import AllIDO from "./AllIDO";

function StatusTab(props) {
  const [key, setKey] = React.useState("allIDO");

  return (
    <>
      <div class="row">
        <div className="col-md-12">
          <div data-v-5b46e2aa="" class="header all__header">
            <div data-v-5b46e2aa="" class="header__top-taber">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="allIDO" title={"All IDOs // "}>
                  <AllIDO />
                </Tab>
                <Tab eventKey="active" title="&nbsp;Active //">
                  <ActiveTab />
                </Tab>
                <Tab eventKey="upcoming" title="&nbsp;Upcoming // ">
                  <UpcomingTab />
                </Tab>
                <Tab eventKey="ended" title="&nbsp;Ended">
                  <EndedTab />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StatusTab;
